export default "__VITE_ASSET__SZwwFl01__"